





import {Component, Vue} from 'vue-property-decorator'
import userSession from "@/store/module/UserSession";
import UserApi from "@/api/UserApi";
import {Inject} from "typescript-ioc";

@Component({})
export default class DashboardView extends Vue {

    @Inject
    private userApi!: UserApi

    async handleLogout() {
        if (userSession.isLogged) {
            await this.userApi.logout()
        }
        this.$redirector.login()
    }
}
